export const constructWebWidgetFlagsmithTrait = ({
  orgId,
  apiKey,
}: {
  orgId: string;
  apiKey: string;
}) => {
  return `${orgId}--x--${apiKey}`;
};
